import React, { Component } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

class CategoriesNavbar extends Component {
  render() {
    const { onCategorySelect } = this.props; // Récupérer la fonction de rappel depuis les props

    const styles = {
      categoriesBar: {
        backgroundColor: '#9DAF7D', 
        padding: '10px 0',
        fontSize: '16px',
        color: '#fff',
        textAlign: 'center',
        position: 'fixed', 
        top: '60px', 
        width: '120%',
        zIndex: '999',
        marginTop: '20px',
        marginLeft: '-50px',
      },
      navLink: {
        display: 'inline-block', 
        color: '#fff',
        margin: '0 15px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        cursor: 'pointer', // Ajouter un curseur pointeur pour les liens
      },
    };

    return (
      <Navbar expand="lg" style={styles.categoriesBar}>
        <Container>
          <Nav className="mx-auto" style={{ display: 'inline-block' }}>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Vêtements')}>
              Vêtements
            </Nav.Link>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Cuisine')}>
              Cuisine
            </Nav.Link>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Electronique')}>
              Electronique
            </Nav.Link>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Soins et Beauté')}>
              Soins et Beauté
            </Nav.Link>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Téléphone et Tablettes')}>
              Téléphone et Tablettes
            </Nav.Link>
            <Nav.Link style={styles.navLink} onClick={() => onCategorySelect('Maison et Bureau')}>
              Maison et Bureau
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
    );
  }
}

export default CategoriesNavbar;
